// The Documents list's filter pieces: a row of toggles in the Filters popover, and the chips
// under the toolbar for the filters in use.

// One filter in the Filters popover as a row of toggles; clicking the chosen one clears it.
export function ChoiceRow({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: string;
  options: readonly (readonly [string, string])[];
  onChange: (v: string) => void;
}) {
  if (!options.length) return null;
  return (
    <div className="pfield">
      <span>{label}</span>
      <div className="opts" role="group" aria-label={label}>
        {options.map(([v, l]) => (
          <button key={v} type="button" aria-pressed={value === v} onClick={() => onChange(value === v ? "" : v)}>
            {l}
          </button>
        ))}
      </div>
    </div>
  );
}

// The filters in use, each removable, under the toolbar.
export function FilterChips({
  chips,
  onRemove,
  onClear,
}: {
  chips: readonly (readonly [string, string])[];
  onRemove: (key: string) => void;
  onClear: () => void;
}) {
  if (!chips.length) return null;
  return (
    <div className="chips">
      {chips.map(([k, t]) => (
        <span key={k} className="chip">
          {t}
          <button type="button" aria-label={`Remove ${t}`} onClick={() => onRemove(k)}>
            ×
          </button>
        </span>
      ))}
      <button type="button" className="linkbtn small" onClick={onClear}>
        Clear filters
      </button>
    </div>
  );
}
